















import { defineComponent } from '@vue/composition-api';

import FooterComponent from '@modules/layout/footer/components/FooterComponent.vue';
import HeaderContainer from '@modules/layout/header/HeaderContainer.vue';

export default defineComponent({
    name: 'AppLoadingLayout',
    components: {
        HeaderContainer,
        FooterComponent,
    },
});
